import { render, staticRenderFns } from "./x-search-list.vue?vue&type=template&id=21a5bb35"
import script from "./x-search-list.vue?vue&type=script&lang=js"
export * from "./x-search-list.vue?vue&type=script&lang=js"
import style0 from "./x-search-list.vue?vue&type=style&index=0&id=21a5bb35&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports